import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";

export const workOrderLogType = v.union(
  v.literal("status_change"),
  v.literal("milestone"),
  v.literal("note"),
  v.literal("inspection"),
  v.literal("photo"),
);

export const validatorWorkOrderLog = v.object({
  workOrderId: v.id("work_orders"),
  type: workOrderLogType,
  description: v.optional(v.string()),
  metadata: v.optional(v.any()),
  recordedBy: v.optional(v.id("users")),
  timestamp: v.optional(v.number()),
  internalControl,
});

export const work_order_logs = defineTableWithInternalControl(
  validatorWorkOrderLog,
)
  .index("by_work_order", ["workOrderId"])
  .index("by_type", ["type"])
  .index("by_work_order_and_type", ["workOrderId", "type"])
  .index("by_company_and_work_order", [
    "internalControl.companyId",
    "workOrderId",
  ])
  .index("by_branch_and_work_order", [
    "internalControl.branchId",
    "workOrderId",
  ])
  .index("by_recorded_by", ["recordedBy"]);
